export default __webpack_public_path__ + "static/media/popup plan 1.30460253.png";